module.exports = __webpack_public_path__ + "img/placeholder.8d2648ad.jpg";